<template>
    <div>
        <b-form @submit.prevent="search">
            <b-form-group
                label="Search"
                label-for="search"
            >
                <b-input-group>
                    <b-form-input ref="search-term" type="search" v-model="search_term" :disabled="searching" required />
                    <b-input-group-append>
                        <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                            <font-awesome-icon :icon="['fad', 'search']" />
                        </b-btn>
                    </b-input-group-append>
                    <b-input-group-append v-if="searched">
                        <b-btn variant="outline-danger" :disabled="searching" @click.prevent="clearSearch">
                            <font-awesome-icon :icon="['fad', 'backspace']" />
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <div v-if="searching" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>

            <div v-else>
                <b-list-group v-if="filtered_printables && filtered_printables.length" class="my-3">
                    <b-list-group-item
                        v-for="(item, index) in filtered_printables"
                        :key="index"
                        class="d-flex align-items-center"
                    >
                        <printable-item
                            :publication="publication"
                            :item="item"
                            :article_related_media="article_related_media"
                            @link="linkItem"
                            @unlink="unlinkItem"
                        />
                    </b-list-group-item>
                </b-list-group>

                <b-alert variant="danger" :show="searched && !filtered_printables.length">
                    0 results
                </b-alert>
            </div>
        </b-form>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import PrintableItem from '@/components/modals/article/worksheets/Item'

export default {
    data: () => ({
        printables: [],

        search_term: '',

        searching: false,
        searched: false
    }),
    props: [
        'publication',
        'article',
        'type',
        'article_related_media'
    ],
    components: {
        PrintableItem
    },
    computed: {
        filtered_printables () {
            return _.filter(this.printables, item => {
                if(!this.type){
                        return item;
                }
                else if(this.type && item.type == this.type) {
                    return item
                }
            })
        }
    },
    methods: {
        async search() {
            if (this.search_term) {
                this.searched = false
                this.searching = true

                this.printables = []

                try {
                    const sanitizedSearch = encodeURIComponent(this.search_term)
                    const response = await this.axios.get(
                        `/api/media/search_printables_with_pdfs/${sanitizedSearch}`
                    )
                    if (response.data) {
                        this.printables = response.data
                    }

                    this.searched = true
                    this.searching = false
                } catch (e) {
                    this.searched = false
                    this.searching = false
                }
            }
        },
        clearSearch () {
            this.search_term = ''

            this.printables = []

            this.searched = false

            this.focusSearch()
        },
        linkItem (item) {
            this.$set(item, 'linking', true)

            this.$emit('link', item)
        },
        unlinkItem (item) {
            this.$set(item, 'linking', false)

            this.$emit('unlink', item)
        },
        focusSearch () {
            if (this.$refs['search-term']) {
                this.$refs['search-term'].focus()
            }
        }
    },
    mounted () {
        this.focusSearch()
    }
}
</script>
